import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AnalyticsService, AuthService, CashboxService, CommerceService } from '@common/services';
import Intercom from '@intercom/messenger-js-sdk';
import { UserService } from '@modules/auth/services';
import { configSection } from '@modules/navigation/data/side-nav-dashboard.data';
import { SideNavItems, SideNavSection } from '@modules/navigation/models';
import { NavigationService } from '@modules/navigation/services';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';

@Component({
    selector: 'sb-side-nav',
    templateUrl: './side-nav.component.html',
    styleUrls: ['side-nav.component.scss'],
})
export class SideNavComponent implements OnInit, OnDestroy {
    @Input() sidenavStyle!: string;
    @Input() sideNavItems!: SideNavItems;
    @Input() sideNavSections!: SideNavSection[];
    configSection = configSection;

    subscription: Subscription = new Subscription();
    routeDataSubscription!: Subscription;

    isCashboxOpen = false;
    private cashboxSubscription!: Subscription;
    enabled = false;

    constructor(
        public navigationService: NavigationService,
        public userService: UserService,
        public analyticsService: AnalyticsService,
        public cashboxService: CashboxService,
        public commerceService: CommerceService,
        private authService: AuthService,
    ) {}

    ngOnInit() {
        this.commerceService._commerce$.pipe(take(2)).subscribe(commerce => {
            if (commerce?.cashBox?.enabled && this.analyticsService.getExperimentVariant('cashbox')) {
                this.cashboxService.loadOpenCashbox().subscribe();
            }
        });
        this.userService.user$.pipe(take(1)).subscribe(user => {
            if (user) {
                const userHash = this.authService.getUserHash();
                const intercomConfig: any = {
                    app_id: environment.INTERCOM_APP_ID,
                    user_id: user._id,
                    name: `${user.name} ${user.lastName}`,
                    email: user.email,
                    phone: user.phone,
                    custom_attributes: {
                        whatsapp_number: user.phone,
                    },
                    company: {
                        company_id: user.tenantId,
                        name: user.tenantId,
                    },
                };

                if (userHash) {
                    intercomConfig.user_hash = userHash;
                }

                Intercom(intercomConfig);
            }
        });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        if (this.cashboxSubscription) {
            this.cashboxSubscription.unsubscribe();
        }
    }

    onToggleSwitch() {
        this.cashboxService.isCashboxOpen = !this.cashboxService.isCashboxOpen$.getValue();
        if (this.cashboxService.isCashboxOpen$.getValue()) {
            this.cashboxService.openCashboxModal();
        }
        if (!this.cashboxService.isCashboxOpen$.getValue()) {
            this.cashboxService.closeCashboxModal();
        }
    }
}
